import { useEffect, useState } from 'react'
import { request } from '../../../Redux/Sagas/requests/api'
import { Table } from 'reactstrap'
import { primary_color } from '../../../Helper/uiHelper'

const BookingList = ({ setSelectedBooking, selectedBooking, queryFormsubHeading, queryFormHeading }) => {
  const [bookingData, setBookingData] = useState([])
  useEffect(() => {
    request('raise-ticket/booking/details', 'POST').then((res) => {
      setBookingData(res?.data)
    })
  }, [])

  const onCheck = (id) => {
    setSelectedBooking((item) => {
      let data = [...item]
      if (data?.includes(id)) {
        const index = data?.indexOf(id)
        data.splice(index, 1)
      } else {
        data.push(id)
      }

      return data
    })
  }
  if (bookingData?.length === 0) return
  return (
    <div>
      {' '}
      <Table hover className='rt-table notes-type-table'>
        <thead className='rt-thead -header'>
          <tr className='rt-tr'>
            <th className='rt-th'></th>
            <th className='subtitle1 font-weight-bold rt-th' style={{ color: primary_color }}>
              Booking ID
            </th>
            <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
              School Name
            </th>
            <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
              Academic Year
            </th>

            <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
              Block Name
            </th>
            <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
              Locker Number
            </th>
            <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
              Status
            </th>
          </tr>
        </thead>
        <tbody className='rt-tr-group'>
          {bookingData?.map((item) => {
            return (
              <tr>
                <td className='rt-td'>
                  <input
                    type='checkbox'
                    checked={selectedBooking?.includes(item.booking_id)}
                    disabled={selectedBooking?.length > 0 && !selectedBooking?.includes(item.booking_id)}
                    onChange={() => {
                      onCheck(item.booking_id)
                    }}></input>
                </td>

                <td className='subtitle1 rt-td'>{item.booking_id}</td>
                <td className='subtitle1 rt-td'>{item.domain_id_label}</td>
                <td className='subtitle1 rt-td'>{item.item_date_time_id_label}</td>
                <td className='subtitle1 rt-td'>{item.location_id_label}</td>
                <td className='subtitle1 rt-td'>{item.item_id_label}</td>
                <td className='subtitle1 rt-td'>{item.status}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  )
}

export default BookingList
